// Master kill-switch for the legacy "Message us on Facebook" CTAs that used
// to route password resets and ban appeals to Messenger. Email-OTP reset
// + in-app support chat replaced the Messenger handoff; flip this to true
// only if those fallbacks are taken offline and Messenger needs to come
// back. Code paths behind it are kept intact for that scenario.
export const SUPPORT_FACEBOOK_ENABLED = false;

export function useSupportUrl() {
  return 'https://www.facebook.com/share/18cawdrb3f/';
}
